import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
export const convertFieldValueToPropertyValue = fieldValue => {
  var _fieldValue$fieldData;
  switch (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.valueType) {
    case 'ENROLLMENT_DATASET_COLUMN':
    case 'ENROLLMENT_EVENT_PROPERTY':
    case 'FETCHED_OBJECT_PROPERTY':
      return new PropertyValue({
        propertyToken: fieldValue.propertyToken,
        type: fieldValue.valueType
      });
    case 'FIELD_DATA':
      return new PropertyValue({
        identifier: fieldValue.fieldDataIdentifier,
        type: fieldValue.valueType,
        value: (_fieldValue$fieldData = fieldValue.fieldDataIdentifier) === null || _fieldValue$fieldData === void 0 ? void 0 : _fieldValue$fieldData.dataKey
      });
    case 'MULTI':
      return new PropertyValue({
        type: 'MULTI_VALUE',
        value: fieldValue.value
      });
    case 'PROPERTY':
      return new PropertyValue({
        propertyName: fieldValue.propertyName,
        type: 'OBJECT_PROPERTY',
        value: fieldValue.propertyName
      });
    case 'RELATIVE_DATETIME':
      return new PropertyValue({
        timeDelay: fieldValue.timeDelay,
        type: fieldValue.valueType
      });
    case 'SINGLE_OBJECT_COORDINATES':
      return new PropertyValue({
        coordinatesToken: fieldValue.coordinatesToken,
        type: fieldValue.valueType
      });
    case 'EXTERNAL':
    case 'SINGLE':
    case 'STATIC':
      return new PropertyValue({
        type: 'STATIC_VALUE',
        value: fieldValue.value
      });
    default:
      return new PropertyValue();
  }
};